import "./Components.css"

/*
 * Draws one colored square per character of the text that was typed in.
 *
 * Each square knows which character it stands for, so hovering over it tells
 * you. That is only true on this page — it is a demonstration of the idea, not
 * a picture of anything the real service stores.
 */
export default function ColorBlocks({ blocks }) {
  return (
    <div
      className="block-grid"
      role="img"
      aria-label={`${blocks.length} color blocks`}
    >
      {blocks.map((block, index) => (
        <span
          key={`${block.char}-${index}`}
          className="color-block"
          style={{ background: block.color }}
          title={block.char}
        />
      ))}
    </div>
  )
}
